import { agsRecordUtils } from "ags/integration/builders/ags-record-utils";
import { AuthRecordBuilder } from "ags/integration/builders/records/auth-record-builder";
import { AgsAuthPublicStateSchema, AgsAuthResponseSchema } from "ags/integration/schema/ags-auth-response-schema";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { builderManager } from "appworks/server/builders/builder-manager";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { Services } from "appworks/services/services";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { GameiomConfigSchema } from "gameiom/schema/gameiom-config-schema";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class ThemeAuthRecordBuilder extends AuthRecordBuilder implements RecordBuilder {
    public override build(gameplay: Gameplay, request: any, response: any): Record[] {
        const authResponse: AgsAuthResponseSchema = JSON.parse(response.data);
        const publicState: AgsAuthPublicStateSchema = authResponse.publicState;
        const config: GameiomConfigSchema = authResponse.config;
        // config.winLines = [9];
        // config.defaultWinLines = 9;

        // Set the spinning reel strips to match the actual math
        const spinningStrips = publicState.spinningReelStrips;
        spinningStrips.forEach(eachSet => {
            slotDefinition.processReelSets(eachSet);
        });

        if(authResponse.config == null) {
            throw(`Config is null in the init response.`);
        }

        this.setCreditValues(config);
        // Services.get(SlotBetService).setFixedBetCost(1);
        // slotModel.write({bet: {fixedBetCost: 1}});

        gameState.autoDeductStake = !slotModel.read().bet.freeBet;

        gameiomModel.rtp = config.rtp;
        if (publicState.jackpots) {
            gameiomModel.jackpotAmounts = this.getJackpotAmounts(publicState.jackpots);
        }
        if (publicState.prizeTable) {
            gameiomModel.prizeTable = publicState.prizeTable;
        }
        if(publicState.paylines) {
            gameiomModel.paylines = publicState.paylines;
        }
        if(publicState.paytable) {
            gameiomModel.paytable = publicState.paytable;
        }

/////////////////////////
///////////////////////////////////////////////
//////////////////

        const multiplier = gameiomModel.isSocial ? 1 : 100;
        gameplay.balance = Math.round(authResponse.platform.balance * multiplier);

        if (authResponse.platform.balanceDetails) {
            gameplay.realBalance = Math.round(authResponse.platform.balanceDetails.real * multiplier);
            gameplay.freeBalance = Math.round(authResponse.platform.balanceDetails.bonus * multiplier);
        } else {
            gameplay.realBalance = gameplay.balance;
            gameplay.freeBalance = 0;
        }

        if (authResponse.publicState.startingSymbols) {
            const dummyRecord = new SpinRecord();
            dummyRecord.results = builderManager.buildResults(dummyRecord, publicState);
            dummyRecord.grid = agsRecordUtils.convertreelsToSlotworksGrid(authResponse.publicState.startingSymbols);
            return [dummyRecord] as Record[];
        }

        return [];
    }
}
